module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ctn-operation-form take-place"
  }, [_c('div', {
    staticClass: "white-box row title"
  }, [_c('router-link', {
    staticClass: "ctn-icon",
    attrs: {
      "to": {
        name: 'SubscriptionsTable'
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), (_vm.subscriptionExist) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tModifier l'abonnement\n\t\t\t")]) : _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\tNouvel abonnement\n\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "white-box"
  }, [_c('edit-main'), _vm._v(" "), (_vm.subscriptionExist) ? _c('div', {
    staticClass: "take-place"
  }, [_c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('edit-docs', {
    attrs: {
      "subscription": _vm.subscription
    },
    on: {
      "needToUpdate": _vm.checkForSubscription
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.subscriptionExist) ? _c('div', {
    staticClass: "take-place"
  }, [_c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('edit-actions', {
    attrs: {
      "subscription": _vm.subscription
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1438e35b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/MySubscriptions/Edit.vue
// module id = 1073
// module chunks = 0